import { useEffect, useRef } from "react";

const useVisibleTrigger = ({ enabled, target, onVisible }) => {
  const onVisibleRef = useRef(onVisible);

  useEffect(() => {
    onVisibleRef.current = onVisible;
  }, [onVisible]);

  useEffect(() => {
    if (!enabled || !target) return undefined;

    let hasTriggered = false;
    const notifyVisible = async () => {
      if (hasTriggered) return;

      hasTriggered = true;
      const isHandled = await onVisibleRef.current?.();
      if (isHandled === false) {
        hasTriggered = false;
      }
    };

    let observer;
    let handleFallbackScroll;

    if (typeof IntersectionObserver === "function") {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          notifyVisible();
        }
      }, { threshold: 1 });
      observer.observe(target);
    } else {
      handleFallbackScroll = () => {
        const bounds = target.getBoundingClientRect();
        if (bounds.top >= 0 && bounds.bottom <= window.innerHeight) {
          notifyVisible();
        }
      };
      window.addEventListener("scroll", handleFallbackScroll, { passive: true });
      handleFallbackScroll();
    }

    return () => {
      observer?.disconnect();
      if (handleFallbackScroll) {
        window.removeEventListener("scroll", handleFallbackScroll);
      }
    };
  }, [enabled, target]);
};

export default useVisibleTrigger;
